const getPopoutOpenedKey = name =>
  `popout-${name}-opened`;

export default getPopoutOpenedKey;